/*
 *
 * Home actions
 *
 */

import * as Types from "./constants";

export function getActivityDetails(slug) {
    return {
        type: Types.GET_ACTIVITY_DETAILS_REQUESTED,
        slug,
    };
}

export function likeActivity(liked) {
    return {
        type: Types.ACTIVITY_LIKED_REQUESTED,
        payload: liked,
    };
}

export function driveActivity(derived) {
    return {
        type: Types.ACTIVITY_DERIVED_REQUESTED,
        payload: derived,
    };
}

export function addActivityComment(body) {
    return {
        type: Types.ADD_ACTIVITY_COMMENT_REQUESTED,
        payload: body,
    };
}

export function replyComment(body) {
    return {
        type: Types.REPLY_TO_COMMENT_REQUESTED,
        payload: body,
    };
}

export function editComment(body) {
    return {
        type: Types.EDIT_COMMENT_REQUESTED,
        payload: body,
    };
}
export function setIsCommentEditMode(id) {
    return {
        type: Types.EDIT_COMMENT_MODE,
        payload: id,
    };
}

export function deleteComment(body) {
    return {
        type: Types.DELETE_COMMENT_REQUESTED,
        payload: body,
    };
}

export function likedOrDislikedComment(body) {
    return {
        type: Types.LIKED_DISLIKED_COMMENT_REQUESTED,
        payload: body,
    };
}

export function appreciateActivity(body) {
    return {
        type: Types.APPRECIATE_ACTIVITY_REQUESTED,
        payload: body,
    };
}

export function setActivityPublic(body) {
    return {
        type: Types.SET_ACTIVITY_PUBLIC_REQUESTED,
        payload: body,
    };
}

export function addActivityAppreciateCandidate(body) {
    return {
        type: Types.ADD_ACTIVITY_APPRECIATE_CANDIDATE_REQUESTED,
        payload: body,
    };
}

export function reportActivity(body) {
    return {
        type: Types.REPORT_ACTIVITY_REQUESTED,
        payload: body,
    };
}

export function punishActivity(body) {
    return {
        type: Types.PUNISH_ACTIVITY_REQUESTED,
        payload: body,
    };
}

export function acceptActivity(body) {
    return {
        type: Types.ACCEPT_ACTIVITY_REQUESTED,
        payload: body,
    };
}

export function activityRegister(body, onUploadProgress) {
    return {
        type: Types.ACTIVITY_REGISTER_REQUESTED,
        payload: body,
        onUploadProgress,
    };
}

export function showSuccess(payload) {
    return {
        type: Types.TOAST_SUCCESS,
        payload: payload,
    };
}

export function showError(payload) {
    return {
        type: Types.TOAST_ERROR,
        payload: payload,
    };
}

export function addSeen(payload) {
    return {
        type: Types.ADD_SEEN,
        payload: payload,
    };
}

export function clearSeen() {
    return {
        type: Types.CLEAR_SEEN,
    };
}

export function setActivityDetail(data) {
    return {
        type: Types.SET_ACTIVITY_DETAIL,
        payload:data
    };
}

export function updateCategorySubject(data) {
    return {
        type: Types.UPDATE_CATEGORY_SUBJECTS_REQUEST,
        payload:data
    };
}
